import kbRedirectTemplate from './kb-redirect.tpl.html';
import './kb-redirect.less';
import { appConfig } from '../../../../shared/app/constants/app-config';

const articleMap = [
  [
    /^assess\/advanced-challenge-ide\/?$/,
    'for-candidates/advanced-challenge-ide/challenge-ide',
  ],
  [
    /^assess\/challenge-solver\/?$/,
    'for-candidates/challenge-solver/challenge-ide',
  ],
  [/^assess(\/.*)?$/, 'for-candidates$1'],
  [/^hire\/account-team(\/.*)?$/, 'reference/account/account-team$1'],
  [
    /^hire\/(assessments|candidates|challenges)(\/.*)?$/,
    'reference/features/$1$2',
  ],
  [/^hire\/tips(.*)$/, 'for-teams/reviewing'],
  [/^hire\/account(\/.*)?$/, 'reference/account/account'],
  [/^hire\/embed$/, 'integrations/custom-integrations/embed'],
  [/^hire\/invite$/, 'for-teams/process/invitations'],
  [/^hire\/live-interview$/, 'for-teams/process/interact'],
  [/^hire\/setup$/, 'for-teams/getting-started/setup'],
  [/^hire(\/?.*)$/, 'for-teams'],
  [/^general(\/?.*)$/, 'reference$1'],
  [/^integrations(\/?.*)$/, 'integrations'], // don't try to line these up
  [/^languages(\/?.*)$/, 'reference/languages$1'],
  [/^changes(\/?.*)$/, 'changes'],
];

export const kbRedirectComponentModule = angular
  .module('Q.components.kb-redirect', [])
  .component('kbRedirect', {
    controller: 'KbRedirectCtrl',
    template: kbRedirectTemplate,
  })

  .controller('KbRedirectCtrl', function KbRedirectCtrl($window, $timeout) {
    const ctrl = this;

    ctrl.$onInit = () => {
      const path = ($window.location.pathname || '').replace(/^\/?kb\//, '');
      let newPath = '';
      articleMap.some(([test, result]) => {
        if (test.test(path)) {
          newPath = path.replace(test, result).replace(/_/g, '-');
          return true;
        }
      });
      ctrl.href = `${appConfig.docsUrl}/${newPath}`;
      $timeout(() => {
        $window.location = ctrl.href;
      });
    };
  });
